module.exports = __webpack_public_path__ + "img/Persepsi-Kinestetik0.39f4bf22.png";